import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { Button, Space, Row } from "@masterteam/mt-design-react";
import { ReactComponent as ErrorIcon } from "../../assets/images/rejected.svg";
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh.svg";

function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.pathname]);

  return (
    <ErrorBoundaryInner hasError={hasError} setHasError={setHasError}>
      {children}
    </ErrorBoundaryInner>
  );
}

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidUpdate(prevProps, _previousState) {
    if (!this.props.hasError && prevProps.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(_error, _errorInfo) {
    this.props.setHasError(true);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Row justify="center" align="center" className="app">
          <Space direction="vertical" align="center" size="large">
            <ErrorIcon fill="var(--error-color)" height={80} width={80} />
            <Space direction="vertical" align="center" size="small">
              <div style={{ fontSize: "var(--font-huge)" }}>
                <FormattedMessage id="error.something-went-wrong" />
              </div>
              <div style={{ fontSize: "var(--font-x)" }}>
                <FormattedMessage id="error.please-refresh" />
              </div>
            </Space>
            <Button
              Icon={RefreshIcon}
              onClick={() => window.location.reload()}
              size="large"
            >
              <FormattedMessage id="common.refresh" />
            </Button>
          </Space>
        </Row>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
